import { useEffect, useState } from "react"

type UseApprovalCountdownProps = {
  createdAt: string
  timeoutSecs?: number | null
  status: string
}

type CountdownState = {
  remainingSecs: number
  progress: number
  isExpiring: boolean
  isExpired: boolean
}

export function useApprovalCountdown({
  createdAt,
  timeoutSecs,
  status,
}: UseApprovalCountdownProps): CountdownState | null {
  const [countdown, setCountdown] = useState<CountdownState | null>(null)

  useEffect(() => {
    if (!timeoutSecs || status !== "pending") {
      setCountdown(null)
      return
    }

    const createdTimestamp = new Date(createdAt).getTime()
    const expiresAt = createdTimestamp + timeoutSecs * 1000

    const updateCountdown = () => {
      const now = Date.now()
      const remainingMs = Math.max(0, expiresAt - now)
      const remainingSecs = Math.ceil(remainingMs / 1000)
      const progress = Math.max(0, Math.min(100, (remainingMs / (timeoutSecs * 1000)) * 100))

      const isExpiring = progress < 30
      const isExpired = remainingSecs === 0

      setCountdown({
        remainingSecs,
        progress,
        isExpiring,
        isExpired,
      })
    }

    updateCountdown()
    const interval = setInterval(updateCountdown, 1000)

    return () => clearInterval(interval)
  }, [createdAt, status, timeoutSecs])

  return countdown
}
